import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function PaymentCancelPage() {
  useEffect(() => {
    document.title = "Pagamento annullato — SWAPA";
  }, []);

  return (
    <div data-testid="payment-cancel-page" className="flex min-h-screen flex-col items-center justify-center bg-ink px-5 py-32 text-center">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-500">Pagamento annullato</p>
      <h1 className="mt-6 font-display text-4xl font-black uppercase tracking-tighter text-white sm:text-6xl">
        Nessun addebito.
      </h1>
      <p className="mt-6 max-w-md text-sm leading-relaxed text-zinc-400">
        Il pagamento è stato annullato e non è stato addebitato alcun importo.
        La tua SWAPA ti aspetta ancora: puoi riprendere il preordine quando vuoi.
      </p>
      <div className="mt-10 flex flex-col gap-3 sm:flex-row">
        <Link to="/preordina" data-testid="cancel-retry-cta" className="bg-swapa-yellow px-8 py-4 font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-black">
          Riprendi il pre-ordine
        </Link>
        <Link to="/" data-testid="cancel-home-link" className="border border-white/25 px-8 py-4 font-mono text-[11px] uppercase tracking-[0.18em] text-white hover:border-swapa-yellow">
          Torna alla home
        </Link>
      </div>
    </div>
  );
}
